import { createApiRequest } from "@/lib/api/createApiService";
import { DASHBOARD_ENDPOINTS } from "./dashboard.endpoints";

export const dashboardService = {
  getKpiSummary: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.KPI_SUMMARY,
      method: "POST",
      body,
      ...options,
    }),

  getAssignedMetricsCompletion: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ASSIGNED_METRICS_COMPLETION,
      method: "POST",
      body,
      ...options,
    }),

  getAssignedMetricsTargetSetup: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ASSIGNED_METRICS_TARGET_SETUP,
      method: "POST",
      body,
      ...options,
    }),

  getAssignedMetricsSummary: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ASSIGNED_METRICS_SUMMARY,
      method: "POST",
      body,
      ...options,
    }),

  getAssignedMetricsCategorySummary: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ASSIGNED_METRICS_CATEGORIES,
      method: "POST",
      body,
      ...options,
    }),

  getAssignedMetricsList: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ASSIGNED_METRICS_LIST,
      method: "POST",
      body,
      ...options,
    }),

  getAssignedMetricsDetail: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ASSIGNED_METRICS_DETAIL,
      method: "POST",
      body,
      ...options,
    }),

  getMetricOverview: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.METRIC_OVERVIEW,
      method: "POST",
      body,
      ...options,
    }),

  getMetricDetail: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.METRIC_DETAIL,
      method: "POST",
      body,
      ...options,
    }),

  getOrgOverview: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ORGANIZATION_OVERVIEW,
      method: "POST",
      body,
      ...options,
    }),

  getOrgDetail: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ORGANIZATION_DETAIL,
      method: "POST",
      body,
      ...options,
    }),

  getConsolidatedMetricOverview: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.CONSOLIDATED_METRIC_OVERVIEW,
      method: "POST",
      body,
      ...options,
    }),

  getConsolidatedMetricDetail: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.CONSOLIDATED_METRIC_DETAIL,
      method: "POST",
      body,
      ...options,
    }),

  getConsolidatedOrgDetail: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.CONSOLIDATED_ORGANIZATION_DETAIL,
      method: "POST",
      body,
      ...options,
    }),

  getEsgDataTable: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.ESG_DATA_TABLE,
      method: "POST",
      body,
      ...options,
    }),

  getEChartsData: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.E_CHARTS,
      method: "POST",
      body,
      ...options,
    }),

  getEChartsTotals: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.E_CHARTS_TOTALS,
      method: "POST",
      body,
      ...options,
    }),

  getEmissionsBreakdown: async (body, options = {}) =>
    createApiRequest({
      url: DASHBOARD_ENDPOINTS.EMISSIONS_BREAKDOWN,
      method: "POST",
      body,
      ...options,
    }),
};
